import React from "react"
import moment from 'moment';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap'
import UserHelper from '../../../../../helper/user.js'
import PermissionProperties from '../../../../../config/permission.js'
import RenderStatus from '../../../../../utils/Render.js'
import {HandlingSometingWentWrong} from '../../../../../utils/HandlingMessage.js'

import isEmpty from 'lodash/isEmpty'
import windowStop from "../../../../../utils/windowStop.js";

export default class ModalUserDetail extends React.Component{
	constructor(){
		super();

		this.initialState 	= {
			selectedData 		: null,
			assetData 			: null,
			assetRow 			: null,
			nextPage 			: null,
			isLoading 			: true,
			loadingLoadMore 	: true,
			isSomethingWrong 	: false,
		}

		this.state = Object.assign({}, this.initialState)
	}

  getInfoArr(arr, get_key) {
    if(!isEmpty(arr)) {
      if(arr.hasOwnProperty(get_key)) {
        if(arr[get_key]) {
          return arr[get_key]
        } else {
          return "-"
        }
      }
    }
  }

	loadMore(){
    	this.setState({ loadingLoadMore : true })
		this.props.assetLoadMore();
	}

	renderAssetLoadMore(){

		if(this.state.loadingLoadMore) {
		    return(
		        <div>
		            <button className="btn btn-default" disabled><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Loading</button>
		        </div>
		    )
		} else {
		    if(this.props.nextPage !== null) {
		        return (
		            <div>
		                <button className="btn btn-primary" onClick={()=> this.loadMore()}>Load More</button>
		            </div>
		        )
		    }
		}
	}

	renderUserRole(){
		if(UserHelper.HasPermission(PermissionProperties.USER.ROLE.READ,this.props.UserReducer)){
			return(
			    <div className="col-md-6" key={1}>
			      <label htmlFor="Name">Role</label>
			        <input
			          type="text"
			          className="form-control"
			          id="Name"
			          placeholder="Enter Role"
			          defaultValue = {this.getInfoArr(this.state.selectedData.Role, "Name")}
			          readOnly
			        />
			    </div>
			)
		}
		return null
	}

	generateAssetRow(assetData){
		let assetList = []
		if (assetData.length > 0){
		  	assetList = assetData.map((val,index) => {
			    let dueDate = val.Tracking.DueDate;
			    if(dueDate === null){
			      dueDate = "-";
			    } else {
			      dueDate = moment(val.Tracking.DueDate).format('ll');
			    }
			    return(
			      <tr key={index}>
			        <td>
			          <div><span className="spaceR">{val.Name}</span>(<span>{val.Alias}</span>)</div>
			          <div className="small text-muted">
			            <span>{moment(val.Tracking.ChekinTime).format('ll')}</span> | <span>{moment(val.Tracking.ChekinTime).fromNow()}</span>
			          </div>
			        </td>
			        <td className="text-center">
			          {dueDate}
			        </td>
			        <td>
			         {val.Site.Name}
			        </td>
			        <td>
			          {val.Location.Name}
			        </td>
			        <td>
			          {val.Status.Name}
			        </td>
			        <td className="text-center">
			          {RenderStatus.MaintenaceStatus(val, this.props)}
			        </td>
			      </tr>
			    )        
		  	})  
		}
		return assetList;
	}

	willMount(){
		// this.setState({ isLoading : true })
	}

	willUnMount(){
		this.setState({ isLoading : true })
	}

	componentWillUnmount() {
		windowStop()
	}

	componentWillReceiveProps(nextProps){
		if(nextProps.selectedData !== null){
			const nextState = {}; 
			nextState.selectedData = nextProps.selectedData
			if(nextProps.assetData !== null){
		        nextState.assetRow        = this.generateAssetRow(nextProps.assetData)
		        nextState.isLoading       = false
		        nextState.loadingLoadMore = false
			}
      	this.setState(nextState)
		}
	}

	render(){
		if(this.state.selectedData === null){
			return null
		}
		return(
			<Modal 
				isOpen={this.props.modalState} 
				onExit={() => this.willUnMount()} 
				onEnter={() => this.willMount()}
				toggle={this.props.closeModal} 
				className={'modal-lg ' + this.props.className}>
			  <ModalHeader toggle={this.props.closeModal}>{'User Details'}</ModalHeader>
			  <ModalBody>
			    <div className="form-group">
			      <label htmlFor="Name">Username</label>
			      <input
			        type="text"
			        className="form-control"
			        id="Name"
			        placeholder="Enter Username"
			        defaultValue = {this.state.selectedData.Username}
			        readOnly
			      />
			    </div>
			    <div className="form-group">
			      <div className="row">
			        <div className="col-md-6">
			        <label htmlFor="Name">First Name</label>
			        <input
			          type="text"
			          className="form-control"
			          id="Name"
			          placeholder="First Name"
			          defaultValue = {this.state.selectedData.FirstName}
			          readOnly
			        />
			        </div>
			        <div className="col-md-6">
			        <label htmlFor="Name">Last Name</label>
			        <input
			          type="text"
			          className="form-control"
			          id="Name"
			          placeholder="Last Name"
			          defaultValue = {this.state.selectedData.LastName}
			          readOnly
			        />
			        </div>
			      </div>
			    </div>
			    <div className="form-group">
			      <div className="row">
			        <div className="col-md-6">
			        <label htmlFor="Name">Email</label>
			        <input
			          type="text"
			          className="form-control"
			          id="Email"
			          placeholder="Email"
			          defaultValue = {this.state.selectedData.Email}
			          readOnly
			        />
			        </div>
			        <div className="col-md-6">
			        <label htmlFor="Name">Phone Number</label>
			        <input
			          type="text"
			          className="form-control"
			          id="Phone"
			          placeholder="Phone"
			          defaultValue = {this.state.selectedData.Phone}
			          readOnly
			        />
			        </div>
			      </div>
			    </div>
			    <div className="form-group">
			      <div className="row">
			        <div className="col-md-6">
			        <label htmlFor="Name">Address</label>
			        <input
			          type="text"
			          className="form-control"
			          id="Email"
			          placeholder="Address"
			          defaultValue = {this.state.selectedData.Address}
			          readOnly
			        />
			        </div>
			        <div className="col-md-6">
			        <label htmlFor="Name">Address 2</label>
			        <input
			          type="text"
			          className="form-control"
			          id="Name"
			          placeholder="Address 2"
			          defaultValue = {this.state.selectedData.Address2}
			          readOnly
			        />
			        </div>
			      </div>
			    </div>
				    <div className="form-group">
				      <div className="row">
				        <div className="col-md-6">
				          <label htmlFor="Name">City</label>
				          <input
				          type="text"
				          className="form-control"
				          id="Name"
				           placeholder="City"
				          defaultValue = {this.getInfoArr( this.state.selectedData.City, "Name")}
				          readOnly
				          />
				        </div>
				        <div className="col-md-6">
				        <label htmlFor="Name">Postal</label>
				        <input
				          type="text"
				          className="form-control"
				          id="Postal"
				          placeholder="Postal"
				          defaultValue = {this.state.selectedData.Postal}
				          readOnly
				        />
				        </div>
				      </div>
				    </div>
				    <div className="form-group">
				      <div className="row">
				        <div className="col-md-6">
				          <label htmlFor="Name">Tag</label>
				          <input
				            type="text"
				            className="form-control"
				            id="Name"
				            placeholder="Tag"
				            defaultValue = {this.state.selectedData.Tag}
				            readOnly
				          />
				        </div>
				        {this.renderUserRole()}
				      </div>
				    </div>
				    <div className="form-group">
				      <label>Asset</label>
				      <div className="table-wrapper">
					      <table className="table table-responsive table-hover table-outline mb-0">
					        <thead className="thead-default">
					          <tr>
					            <th>Asset/Tool</th>
					            <th className="text-center">Due Date</th>
					            <th>Site</th>
					            <th>Location</th>
					            <th>Status</th>
					            <th>Maintenance</th>
					          </tr>
					        </thead>
					        <tbody>
					        	{	
					        		this.props.renderRowElement(
					        			this.state.assetRow,
					        			this.state.isLoading,
					        			false,
					        			HandlingSometingWentWrong,
					        			'User Has No Asset'
					        		)
					        	}				        	
					        </tbody>
					      </table>
					   </div>
				    </div>
			      <div className="col-md-12 text-center">
			        {this.renderAssetLoadMore()}
			      </div>
				</ModalBody>
				<ModalFooter>
					<Button color="danger" onClick={() => this.props.closeModal()}>Close</Button>
				</ModalFooter>
			</Modal>
		)
	}
}


// WEBPACK FOOTER //
// ./src/App/user/userHaveAsset/helper/component/Modal/ModalUserDetail.js